import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
  Button,
  Tooltip,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import messages from '../messages';

const GenerateSubmissionFileButton = ({
  disabled,
  showToolTip,
  onGenerateClick,
  isGenerating,
  intl,
}) => {
  const button = (
    <Button
      variant={'shout'}
      disabled={disabled}
      intl={intl}
      onClick={disabled ? undefined : onGenerateClick}
    >
      <FormattedMessage
        {...(isGenerating
          ? messages.generating
          : messages.generateSubmissionFile)}
      />
    </Button>
  );
  return (
    <>
      {showToolTip ? (
        <Tooltip
          id={'generatePicSubmissionTooltip'}
          title={<FormattedMessage {...messages.mustSelectOneRow} />}
        >
          {button}
        </Tooltip>
      ) : (
        button
      )}
    </>
  );
};

export default GenerateSubmissionFileButton;
